module.exports = __WEBPACK_EXTERNAL_MODULE_52__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"sinon","commonjs":"sinon","commonjs2":"sinon","root":"sinon"}
 ** module id = 52
 ** module chunks = 1 2
 **/